var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('veStuGraduation',{attrs:{"slot":"table","viewType":"yx","print":""},slot:"table"})}
var staticRenderFns = []

export { render, staticRenderFns }